module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-left-circle-fill-d23784ba.svg";